module.exports = __webpack_public_path__ + "static/img/background.27a69dd6.svg";